"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoCodesService = void 0;
class PromoCodesService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Returns a paged set of promo codes.
     * @param promoCodeListId
     * @param q
     * @param page
     * @param count
     * @returns PromoCodesResponse
     * @throws ApiError
     */
    getPromoCodes(promoCodeListId, q, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/promocodes',
            query: {
                'promoCodeListId': promoCodeListId,
                'q': q,
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Create a promoCode
     * @param requestBody
     * @returns PromoCodeResponse
     * @throws ApiError
     */
    createPromoCode(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/promocodes',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Returns a specific promoCode by id.
     * @param id
     * @returns PromoCodeResponse
     * @throws ApiError
     */
    getPromoCode(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/promocodes/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update a promoCode
     * @param id
     * @param requestBody
     * @returns PromoCodeResponse
     * @throws ApiError
     */
    updatePromoCode(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/promocodes/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete a promoCode
     * @param id
     * @returns any Successful response
     * @throws ApiError
     */
    deletePromoCode(id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/promocodes/{id}',
            path: {
                'id': id,
            },
        });
    }
}
exports.PromoCodesService = PromoCodesService;
